import { useCallback } from 'react';
import { useQuery, useQueryClient } from '../query';
const queryKey = ['operationalStatus'];
export const useOperationalStatus = () => {
    const queryClient = useQueryClient();
    // switch to useState?
    const { data: operationalStatus } = useQuery({
        queryKey,
        queryFn: () => 'normal',
        enabled: false,
        initialData: 'normal',
    }, queryClient);
    const setOperationalStatus = useCallback((nextState) => {
        queryClient.setQueryData(queryKey, nextState);
    }, [queryClient]);
    return [operationalStatus, setOperationalStatus];
};
//# sourceMappingURL=useOperationalStatus.js.map